export default __webpack_public_path__ + "static/media/lite.e9fe175b.png";